import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams, useHistory } from 'react-router-dom';
import { ValidatorForm } from 'react-form-validator-core';
import TextValidator from '../components/TextValidator';
import SelectValidator from '../components/SelectValidator';
import TextAreaValidator from '../components/TextAreaValidator';
import Loader from "../components/Loader";
import Spinner from "../components/Spinner";
import Swal from 'sweetalert2'

function AddEditProduct(props) {
    const { idProduct } = useParams();
    const history = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const [isLoaded, setIsLoaded] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [approvedStatus, setApprovedStatus] = useState(true);
    const [approverComment, setApproverComment] = useState("");
    const [homePage, setHomePage] = useState("");
    const [productName, setproductName] = useState("");
    const [productCompanyId, setProductCompanyId] = useState();
    const [alcohol, setAlcohol] = useState();
    const [picturelink, setPicturelink] = useState("");
    //const [picturefile, setPicturefile] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [pieces, setPieces] = useState("");
    const [deservePeriodNumber, setDeservePeriodNumber] = useState("");
    const [deservePeriodUnit, setDeservePeriodUnit] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [categoryId, setcategoryId] = useState("");
    const [activeCompanyId, setActiveCompanyId] = useState();


    useEffect(() => {
        async function getProduct() {
            const token = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", token);

            const response = await fetch(`${serverUrl}/api/addEditProduct/` + idProduct,
                { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
            const product = await response.json();
            setProduct(product);
            setIsLoaded(true);
            setIsRunning(false);
        }

        if (idProduct) {
            getProduct();
        }
        else {
            setIsLoaded(true);
            setIsRunning(false);
        }

        try {
            //Set selectedCompany from localStorage
            setActiveCompanyId(JSON.parse(localStorage.getItem('selectedCompany'))?.idCompany);
        }
        catch { }


    }, []);

    function setProduct(products) {
        let product = products[0];//Handle null condition
        setproductName(product.name);
        setHomePage(product.homePage);
        setApprovedStatus(product.approvedStatus);
        setApproverComment(product.approverComment);
        setDescription(product.details);
        setAlcohol(!!product.alcohol);
        setPrice(product.price);
        setPieces(product.quantity);
        setPicturelink(product.imageUrl);
        setDeservePeriodNumber(product.timeperiode);
        setDeservePeriodUnit(product.timeperiodeCurrency);
        setStartDate(new Date(product.timeperiodeFrom).toISOString().split("T")[0]);
        setEndDate(new Date(product.timeperiodeTo).toISOString().split("T")[0]);
        setcategoryId(product.categoryId);
        setProductCompanyId(product.idCompany);
    }

    const handleSubmit = async (event) => {

        swalWithBootstrapButtons.fire({
            title: "Bist Du sicher, dass Du speichern möchtest?",
            text: "",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Ja, speichern!",
            cancelButtonText: "Nein, abbrechen!",
            //reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                speichern(event)
            }
        });
    }

    ValidatorForm.addValidationRule('safeUnicodeText', (value) => {
        if (typeof value !== 'string') return false;
        try {
            const regex = /^[\p{L}\p{N} @*./#&+\-]*$/u;
            return regex.test(value);
        } catch (err) {
            // fallback for environments that don't support Unicode regex
            const fallback = /^[a-zA-Z0-9 @*./#&+\-]*$/;
            return fallback.test(value);
        }
    });

    //Add custom rules for        
    ValidatorForm.addValidationRule('isEndDateSmallerThanStartDate', (value) => {
        let x = new Date(value);
        let y = new Date(startDate);
        if (x > y)
            return true;
        return false;
    });

    //Custom Logic to add days to date
    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }
    //Add custom rules for        
    ValidatorForm.addValidationRule('isEndDateSmallerThanStartDatePlusMinimumLikeDays', (value) => {
        let x = new Date(value);
        let y = new Date(startDate);

        let additonalDays = 0;

        if (["Days", "Tage"].includes(deservePeriodUnit)) {
            additonalDays = parseInt(deservePeriodNumber);
        }
        else if (deservePeriodUnit == "Weeks") {
            additonalDays = parseInt(deservePeriodNumber) * 7
        }

        //Add the days
        additonalDays += parseInt(y.getUTCDate());
        y.setUTCDate(additonalDays);

        //For month either consider 30 days or calculate special date based on number of days in that month.
        //Eg. Feb won't have 30th,31st Date
        if (x > y)
            return true;
        return false;
    });



    const handleInputChange = (event) => {
        const { name, value } = event.target;
        // Implement your logic for handling input change
        switch (name) {
            case "homePage":
                setHomePage(value);
                break;
            case "productName":
                setproductName(value);
                break;
            case "picturelink":
                setPicturelink(value);
                break;
            case "price":
                setPrice(value);
                break;
            case "pieces":
                setPieces(value);
                break;
            case "deservePeriodNumber":
                setDeservePeriodNumber(value);
                break;
            case "deservePeriodUnit":
                setDeservePeriodUnit(value);
                break;
            case "description":
                setDescription(value);
                break;
            case "alcohol":
                setAlcohol(event.target.checked);
                break;
            case "startDate":
                setStartDate(value);
                break;
            case "endDate":
                setEndDate(value);
                break;
            case "categoryId":
                setcategoryId(value);
                break;
            // Add cases for other input fields
            default:
                break;
        }
    }


    const backToAllProducts = () => {
        try {
            history.push("/allMyProducts");
        } catch (error) {
            swalWithBootstrapButtons.fire({
                title: "Oops...",
                text: error.message,
                icon: "error"
            });
        }
    }

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-outline-warning",
            cancelButton: "btn btn-outline-warning"
        },
        buttonsStyling: false
    });


    const speichern = async (event) => {
        try {
            event.preventDefault();
            const accessToken = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", accessToken);

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", `Bearer ${accessToken}`);

            //Add character validations on each property
            const productDetails = JSON.stringify({
                "idProduct": idProduct,
                "name": productName,
                "homePage": homePage,
                "details": description, //Product Description
                "imageUrl": picturelink,
                "price": price, //Number of likes required
                "quantity": pieces, // Number of items/quantity of deserves
                "timeperiode": deservePeriodNumber, //Number of days/week/month to earn likes
                "timeperiodeCurrency": deservePeriodUnit, //Unit
                "timeperiodeFrom": startDate,
                "timeperiodeTo": endDate,
                "categoryId": categoryId,
                "alcohol": alcohol ? 1 : 0,
                "idCompany": idProduct ? productCompanyId : activeCompanyId
            });

            const requestOptions = {
                headers: myHeaders,
                body: productDetails,
                redirect: "follow"
            };
            let url;
            if (idProduct) {
                //edit
                requestOptions.method = "PUT";
                url = `${serverUrl}/api/addEditProduct/` + idProduct;
            }
            else {
                //Add
                requestOptions.method = "POST";
                url = `${serverUrl}/api/addEditProduct/`;
            }

            let response = await fetch(url, requestOptions);
            let result = await response.json();

            if (result.isSuccessful) {
                swalWithBootstrapButtons.fire({
                    title: "Gespeichert!",
                    text: "",
                    icon: "success"
                });
                backToAllProducts();//Go back all products page.
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.message,
                    //footer: '<a href="#">Why do I have this issue?</a>'
                });
            }
        } catch (err) {
            // catches errors both in fetch and response.json
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err,
                //footer: '<a href="#">Why do I have this issue?</a>'
            });
        }
    }

    return (
        <React.Fragment>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">{idProduct?.toString().trim() == "" ? "Produkt hinzufügen" : "Produkt bearbeiten"}</h1>
                        </div>
                        {/* <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="#">{"Startseite"}</a></li>
                                <li className="breadcrumb-item active">{idProduct?.toString().trim() == "Titel" ? "Produkt hinzufügen" : "Produkt bearbeiten"}</li>
                            </ol>
                        </div> */}
                    </div>
                </div>
            </section>

            <section className="content">
                <div className="card card-solid">
                    <Spinner isRunning={isRunning} />

                    {!isLoaded ? <div className="text-center"><Loader /></div> :
                        <div className="container-fluid">
                            {idProduct && approvedStatus == 0 &&
                                <div className="alert alert-danger">Das Produkt muss noch genehmigt werden.</div>}
                            {idProduct && approvedStatus == -1 &&
                                <div className="alert alert-danger">Das Produkt wurde von der Administration abgelehnt: {approverComment}</div>}

                            <ValidatorForm onSubmit={handleSubmit}>
                                <div className="box-body">
                                    <div className="alert alert-success" id="successMessage" style={{ display: 'none' }}></div>
                                    <div className="alert alert-danger" id="errorMessage" style={{ display: 'none' }}></div>
                                    <div className="form-group">
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    name="homePage"
                                                    value={homePage ? homePage : ""}
                                                    isRequired={false}
                                                    placeholder={"Homepage"}
                                                    label={<React.Fragment>
                                                        {"Homepage"}&nbsp;
                                                        <i className="fa fa-info-circle fa-xs" data-for={"Homepage"} data-tip></i>
                                                    </React.Fragment>}
                                                    //ref={nameRef}
                                                    withRequiredValidator={true}
                                                    infotext={"Gib den Link Ihrer Homepage oder Produktdetails an"}
                                                    validators={["required", "maxStringLength:250"]}
                                                    errorMessages={["Gib den Link zu Ihrer Homepage oder den Produktdetails ein.", "Maximal 250 Zeichen erlaubt."]} />

                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    name="productName"

                                                    value={productName ? productName : ""}
                                                    isRequired={false}
                                                    //label={t('customer.addeditproduct.internalproductname')}
                                                    placeholder={"Produktname"}
                                                    // tooltip={
                                                    //     <ToolTip type="name">
                                                    //     </ToolTip>}

                                                    label={<React.Fragment>
                                                        {"Produktname"}&nbsp;
                                                        <i className="fa fa-info-circle fa-xs" data-for={"productName"} data-tip></i>
                                                    </React.Fragment>}
                                                    //ref={nameRef}
                                                    withRequiredValidator={true}
                                                    infotext={"Verwende Buchstaben und Zahlen."}
                                                    //validators={["required", "matchRegexp:^[a-zA-Z0-9 ]+[a-zA-Z0-9 @*./#&+-]*$", "minStringLength:3", "maxStringLength:64"]}
                                                    validators={["required", "safeUnicodeText", "minStringLength:3", "maxStringLength:64"]}
                                                    errorMessages={["Gib einen Namen ein.", "Verwende nur Buchstaben und Zahlen.", "Verwende mindestens 3 Zeichen.", "Maximal 64 Zeichen erlaubt."]} />

                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    name="picturelink"
                                                    value={picturelink ? picturelink : ""}
                                                    isRequired={true}
                                                    label={"Bildlink für den Post"}
                                                    infotext={"Das Bild wird auch für die Anzeige unter Produkte verwendet."}
                                                    placeholder="https://... Link"
                                                    //ref={nameRef}
                                                    withRequiredValidator={true}
                                                    validators={["required", "maxStringLength:250"]}
                                                    errorMessages={["Gib einen Bildlink ein.", "Maximal 250 Zeichen erlaubt."]} />

                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 col-xs-12">

                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    name="price"
                                                    type="number"
                                                    value={price ? price : ""}
                                                    key="Price"
                                                    isRequired="true"
                                                    label={"Benötigte Likes"}
                                                    placeholder={"Benötigte Likes"}
                                                    infotext={"Faustregel: 1 Like = CHF 0.50"}
                                                    withRequiredValidator={true}
                                                    validators={["required", 'isNumber', 'minNumber:1']}
                                                    errorMessages={["Wieviele Likes werden benötigt?", "Nur Zahlen.", "Der Wert sollte mindestens 1 sein."]} />
                                            </div>

                                            <div className="col-md-3 col-xs-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    name="pieces"
                                                    type="number"
                                                    value={pieces ? pieces : ""}
                                                    key="Pieces"
                                                    isRequired="true"
                                                    label={"Anzahl Stücke"}
                                                    placeholder={"Anzahl Stücke"}
                                                    withRequiredValidator={true}
                                                    validators={["required", 'isNumber', 'minNumber:1']}
                                                    errorMessages={["Wieviele identische Produkte werden vergeben?", "Nur Zahlen.", "Der Wert sollte mindestens 1 sein."]} />
                                            </div>

                                            <div className="col-md-3 col-xs-12">
                                                <TextValidator
                                                    onChange={handleInputChange}
                                                    name="deservePeriodNumber"
                                                    type="number"
                                                    value={deservePeriodNumber ? deservePeriodNumber : ""}
                                                    key="deservePeriodNumber"
                                                    isRequired="true"
                                                    label={"deserve Periode (Anzahl Tage)"}
                                                    placeholder={"deserve Periode (Anzahl Tage)"}
                                                    withRequiredValidator={true}
                                                    validators={["required", 'isNumber', 'minNumber:1']}
                                                    errorMessages={["Gib an, wie viele Tage eine Person das Produkt deserven darf.", "Nur Zahlen.", "Der Wert sollte mindestens 1 sein."]} />
                                            </div>

                                            {/*
                                            <div className="col-md-3 col-xs-12">
                                                <SelectValidator
                                                    onChange={handleInputChange}
                                                    name="deservePeriodUnit"
                                                    isRequired={true}
                                                    label={"deserve Periode Einheit"}
                                                    placeholder={"deserve Periode Einheit"}
                                                    //ref={nameRef}
                                                    withRequiredValidator={true}
                                                    value="Days"  // Standardwert auf "Tage" gesetzt
                                                    validators={['required']}
                                                    errorMessages={["Wählen Sie die Art des Zeitraums (Tage, Wochen...)."]}
                                                    disabled={true}  // Dropdown deaktiviert
                                                >
                                                    <option disabled hidden value=""> </option>
                                                    <option value="Days">{"Tage"}</option>
                                                    <option value="Weeks">{"Wochen"}</option>
                                                    <option value="Months">{"Monate"}</option>
                                                </SelectValidator>
                                            </div>
                                            */}

                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 col-xs-12">
                                                <SelectValidator
                                                    onChange={handleInputChange}
                                                    name="categoryId"
                                                    isRequired={true}
                                                    label={"Produktkategorie"}
                                                    placeholder={"Produktkategorie"}
                                                    //ref={nameRef}
                                                    withRequiredValidator={true}
                                                    value={categoryId ? categoryId : ""}
                                                    validators={['required']}
                                                    errorMessages={["Wähle den Kategorietyp [Produkt, Restaurant...]."]}
                                                >
                                                    <option value={""}></option>
                                                    <option value="1">{"Restaurantbesuch"}</option>
                                                    <option value="2">{"Produkt"}</option>
                                                </SelectValidator>
                                            </div>
                                            <div className="col-md-3 col-xs-12">
                                                <div className="form-check mt-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="alcohol"
                                                        name="alcohol"
                                                        checked={alcohol === true}
                                                        onChange={(e) => setAlcohol(e.target.checked)}
                                                    />
                                                    <label className="form-check-label" htmlFor="alcohol">
                                                        Dieses Produkt enthält Alkohol
                                                    </label>
                                                    <small className="form-text text-muted">
                                                        Das Ankreuzen hat zur Folge, dass der/die deserver/in 18+ sein muss.
                                                    </small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-md-12">
                                                <TextAreaValidator
                                                    onChange={handleInputChange}
                                                    name="description"
                                                    value={description ? description : ""}
                                                    label={"Produktbeschreibung"}
                                                    placeholder={"Produktbeschreibung"}
                                                    rows={5}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-md-6 col-xs-12">
                                                <div className="form-group" >
                                                    <TextValidator type="date"
                                                        name={"startDate"}
                                                        key={"startDate"}
                                                        infotext={"Zeitraum, zwischen welchem das Produkt deserved werden darf"}
                                                        value={startDate ? startDate : ""}
                                                        onChange={handleInputChange}
                                                        label={<React.Fragment>
                                                            {"Startdatum"}&nbsp;
                                                            <i className="fa fa-info-circle fa-xs" data-for={"startDate"} data-tip></i>
                                                        </React.Fragment>}
                                                        withRequiredValidator={true}
                                                        validators={["required"]}
                                                        errorMessages={["Gib den Wert des Startdatums ein."]} />
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-12">
                                                <div className="form-group" >
                                                    <TextValidator type="date"
                                                        name={"endDate"}
                                                        key={"endDate"}
                                                        value={endDate ? endDate : ""}
                                                        onChange={handleInputChange}
                                                        label={<React.Fragment>
                                                            {"Enddatum"}&nbsp;
                                                            <i className="fa fa-info-circle fa-xs" data-for={"endDate"} data-tip></i>
                                                        </React.Fragment>}
                                                        withRequiredValidator={true}
                                                        validators={["required", "isEndDateSmallerThanStartDate", "isEndDateSmallerThanStartDatePlusMinimumLikeDays"]}
                                                        errorMessages={["Gib ein Enddatum an", "Das Enddatum muss nach dem Startdatum liegen.", "Das Enddatum muss weiter in der Zukunft liegen."]} />
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div className="box-footer">
                                    <div className="form-group">
                                        <div className="col-md-12">
                                            <div>
                                                <input type="submit" value={"Speichern"} className="btn btn-outline-warning col-md-6" />
                                                <input type="button" value={"Abbrechen"} className="btn btn-outline-warning col-md-6" onClick={backToAllProducts} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ValidatorForm>

                        </div>

                    }
                </div>
            </section>
        </React.Fragment>
    );
};
export default AddEditProduct;

